import get from "lodash/get";
import {
  getTransformedMinutes,
  convertTimeRangeToAmPm,
} from "../../../utilities/helpers";

import React from "react";
import round from "lodash/round";

const getRowSpan = (text, dataIndex, rowIndex, tableData) => {
  const value = get(tableData, `[${rowIndex}][${dataIndex}]`);
  if (
    rowIndex === 0 ||
    get(tableData, `[${rowIndex - 1}][${dataIndex}]`) !== value
  ) {
    let rowSpan = 1;
    for (let i = rowIndex + 1; i < get(tableData, "length"); i++) {
      if (get(tableData, `[${i}][${dataIndex}]`) === value) {
        rowSpan++;
      } else {
        break;
      }
    }
    return rowSpan;
  }
  return 0;
};

const getTimeSummaryColumns = (tableData, filter) => {
  const columns = [
    {
      title: "Shift",
      dataIndex: "shift_name",
      key: "shift_name",
      minWidth: 100,
      onCell: (record, rowIndex) => ({
        rowSpan: getRowSpan(
          get(record, "shift_name"),
          "shift_name",
          rowIndex,
          tableData,
        ),
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
      onHeaderCell: () => ({
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
      render: (text) => text || "--",
      responsive: ["xs", "sm", "md", "lg"],
    },
    {
      title: "Operator",
      dataIndex: "operator",
      key: "operator",
      width: 80,
      onCell: (record, rowIndex) => ({
        rowSpan: getRowSpan(
          get(record, "shift_name"),
          "shift_name",
          rowIndex,
          tableData,
        ),
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
      onHeaderCell: () => ({
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
      render: (text) => text || "--",
    },
    {
      title: "Supervisor",
      dataIndex: "supervisor",
      key: "supervisor",
      width: 80,
      onCell: (record, rowIndex) => ({
        rowSpan: getRowSpan(
          get(record, "shift_name"),
          "shift_name",
          rowIndex,
          tableData,
        ),
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
      onHeaderCell: () => ({
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
      render: (text) => text || "--",
    },

    {
      title: "PC",
      dataIndex: "component",
      key: "component",
      onCell: (record, rowIndex) => ({
        rowSpan: getRowSpan(
          get(record, "time_range"),
          "time_range",
          rowIndex,
          tableData,
        ),
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
      onHeaderCell: () => ({
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
      render: (text) => text || "--",
    },
    {
      title: "Customer",
      dataIndex: "customer",
      key: "customer",
      width: 100,
      onCell: (record, rowIndex) => ({
        rowSpan: getRowSpan(
          get(record, "time_range"),
          "time_range",
          rowIndex,
          tableData,
        ),
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
      onHeaderCell: () => ({
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
      render: (text, record) => {
        console.log("text====>", text, record);
        return text;
      },
    },
    ...templateCycleColumns(get(filter, "templateType"), tableData),
    {
      title: "Time",
      dataIndex: "time_range",
      key: "time_range",
      width: 100,
      onCell: (record, rowIndex) => ({
        rowSpan: getRowSpan(
          get(record, "time_range"),
          "time_range",
          rowIndex,
          tableData,
        ),
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
      onHeaderCell: () => ({
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
      render: (text, record) => convertTimeRangeToAmPm(text),
    },
    {
      title: "Power Cons. (in Kwh)",
      dataIndex: "total_power_consumption",
      key: "total_power_consumption",
      width: 80,
      onCell: (record, rowIndex) => ({
        rowSpan: getRowSpan(
          get(record, "time_range"),
          "time_range",
          rowIndex,
          tableData,
        ),
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
      onHeaderCell: () => ({
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
      render: (text) =>
        text === undefined || text === null ? `--` : `${text}`,
    },
    {
      title: "Idle Time (in Hrs)",
      dataIndex: "total_idle_hours",
      key: "total_idle_hours",
      render: (text) =>
        text || text === 0 ? `${getTransformedMinutes(text)}` : "0",
      onCell: (record, rowIndex) => ({
        rowSpan: getRowSpan(
          get(record, "time_range"),
          "time_range",
          rowIndex,
          tableData,
        ),
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
      onHeaderCell: () => ({
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
    },
    {
      title: "OFF Time (in Hrs)",
      dataIndex: "total_off_hours",
      key: "total_off_hours",
      render: (text) =>
        text || text === 0 ? `${getTransformedMinutes(text)}` : "0",
      onCell: (record, rowIndex) => ({
        rowSpan: getRowSpan(
          get(record, "time_range"),
          "time_range",
          rowIndex,
          tableData,
        ),
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
      onHeaderCell: () => ({
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
    },
    {
      title: "Parts",
      dataIndex: "part_name",
      minWidth: 150,
      key: "part_name",
      onCell: (record) => ({
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
      onHeaderCell: () => ({
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
      render: (text) => text || "--",
    },
    ...timeSummaryTemplateColumns(get(filter, "templateType")),
    {
      title: "OEE",
      dataIndex: "oee",
      key: "oee",
      onCell: (record) => ({
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
      onHeaderCell: () => ({
        style: {
          padding: "4px",
          textAlign: "center",
          fontSize: "12px",
          fontFamily: "Arial",
        },
      }),
      render: (text) => (text ? round(text) : "0"),
    },
  ];
  return columns;
};

export default getTimeSummaryColumns;

const templateCycleColumns = (templateType, tableData) => {
  switch (templateType) {
    case 1:
      return [
        {
          title: "Target Cycle",
          dataIndex: "planned_cycle_time",
          key: "planned_cycle_time",
          onCell: (record, rowIndex) => ({
            rowSpan: getRowSpan(
              get(record, "time_range"),
              "time_range",
              rowIndex,
              tableData,
            ),
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text) => text || 0,
        },
        {
          title: "Actual Cycle",
          dataIndex: "avg_cycle_time",
          key: "avg_cycle_time",
          onCell: (record, rowIndex) => ({
            rowSpan: getRowSpan(
              get(record, "time_range"),
              "time_range",
              rowIndex,
              tableData,
            ),
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text) => text || 0,
        },
        {
          title: "Product Eff.",
          dataIndex: "product_efficiency",
          key: "product_efficiency",
          onCell: (record, rowIndex) => ({
            rowSpan: getRowSpan(
              get(record, "time_range"),
              "time_range",
              rowIndex,
              tableData,
            ),
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text) => text || 0,
        },
        {
          title: "M/C Eff",
          dataIndex: "machine_efficiency",
          key: "machine_efficiency",
          onCell: (record, rowIndex) => ({
            rowSpan: getRowSpan(
              get(record, "time_range"),
              "time_range",
              rowIndex,
              tableData,
            ),
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text) => text || 0,
        },
      ];
    case 2:
    case 3:
    case 4:
    default:
      return [];
  }
};
const timeSummaryTemplateColumns = (templateType) => {
  switch (templateType) {
    case 1:
      return [
        {
          title: "Cavity",
          dataIndex: "cavity",
          key: "cavity",
          onCell: (record) => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text) => text || "0",
        },
        {
          title: "Shots",
          dataIndex: "shots",
          key: "shots",
          onCell: (record) => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text, record) => (
            <>
              {get(record, "shots") === undefined ||
              get(record, "shots") === null
                ? "0"
                : get(record, "shots")}
            </>
          ),
        },
        {
          title: "Counts",
          dataIndex: "counts",
          key: "counts",
          onCell: (record) => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text, record) => (
            <>
              {get(record, "counts") === undefined ||
              get(record, "counts") === null
                ? "0"
                : get(record, "counts")}
            </>
          ),
        },
        {
          title: "Rejected Pcs",
          dataIndex: "rejected_count",
          key: "rejected_count",
          onCell: (record) => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text) => (text ? `${text}` : "0"),
        },
        {
          title: "Part weight (in Kgs)",
          dataIndex: "part_weight",
          key: "total_part_weight",
          onCell: (record) => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text) => (text ? `${round(text / 1000, 2)}` : "0"),
        },
        {
          title: "Shot weight (in Kgs)",
          dataIndex: "shot_weight",
          key: "total_shot_weight",
          onCell: (record) => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text) => (text ? `${round(text / 1000, 2)}` : "0"),
        },
      ];
    case 2:
      return [
        {
          title: "Length [in meter]",
          dataIndex: "length",
          key: "length",
          onCell: (record) => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text) => text || "0",
        },

        {
          title: "Scrap",
          dataIndex: "rejected_scrap",
          key: "rejected_scrap",
          onCell: (record) => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text) => (text ? `${text}` : "--"),
        },
        {
          title: "Part weight (in Kgs)",
          dataIndex: "part_weight",
          key: "extrution_part_weight",
          onCell: (record) => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text) => (text ? `${round(text / 1000, 2)}` : "0"),
        },
      ];
    case 3:
      return [
        {
          title: "Press Cycle",
          dataIndex: "press_cycle",
          key: "total_press_cycle",
          onCell: (record) => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text) => (text ? text : 1),
        },
        {
          title: "Shots",
          dataIndex: "shots",
          key: "shots",
          onCell: (record) => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text) => text || "0",
        },
        {
          title: "Counts",
          dataIndex: "count",
          key: "count",
          onCell: (record) => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text) => text || "0",
        },

        {
          title: "Rejected Pcs",
          dataIndex: "rejected_count",
          key: "rejected_count",
          onCell: (record) => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text) => (text ? `${text}` : 0),
        },
        {
          title: "Part weight (in Kgs)",
          dataIndex: "part_weight",
          key: "punch_press_part_weight",
          onCell: (record) => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text) => (text ? `${round(text / 1000, 2)}` : "0"),
        },
      ];
    case 4:
      return [
        {
          title: "No of operations",
          dataIndex: "machining_cycle",
          key: "machining_cycle",
          onCell: (record) => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text) => text || "0",
        },
        {
          title: "Shots",
          dataIndex: "shots",
          key: "shots",
          onCell: (record) => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text, record) => (
            <>
              {get(record, "shots") === undefined || text === null
                ? "0"
                : get(record, "shots")}{" "}
            </>
          ),
        },
        {
          title: "Production",
          dataIndex: "count",
          key: "count",
          onCell: (record) => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text, record) => (
            <>
              {get(record, "count") === undefined ||
              get(record, "count") === null
                ? "0"
                : get(record, "count")}
            </>
          ),
        },
        {
          title: "Rejected Pcs",
          dataIndex: "rejected_count",
          key: "rejected_count",
          onCell: (record) => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text) => (text ? `${text}` : "0"),
        },
        {
          title: "Total Raw weight (in Kgs)",
          dataIndex: "total_raw_weight",
          key: "total_raw_weight",
          onCell: (record) => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text) => (text ? `${round(text / 1000, 2)}` : "0"),
        },
        {
          title: "Finished weight (in Kgs)",
          dataIndex: "total_finished_weight",
          key: "total_finished_weight",
          onCell: (record) => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          onHeaderCell: () => ({
            style: {
              padding: "4px",
              textAlign: "center",
              fontSize: "12px",
              fontFamily: "Arial",
            },
          }),
          render: (text) => (text ? `${round(text / 1000, 2)}` : "0"),
        },
      ];
  }
};
